// DepartmentDropdown.js

import React, { useEffect, useState } from "react";
import { Form, Select } from 'antd';
import DepartmentsApi from '../Apis/DepartmentsApi';
import {
    ReloadOutlined,
    SyncOutlined,
} from "@ant-design/icons";
import { Link } from "react-router-dom";
import CoolingShelfApi from "../Apis/CoolingShelfApi";

const CoolingShelfModel = ({ onCoolingShelfResponse }) => {

    const [CoolingShelfLife, setCoolingShelfLifes] = React.useState([]);
    const [loading, setLoading] = useState(false);
    const [TotalPageNew, setTotalPageNew] = useState(null);
    const [page, setPage] = useState(0);

    const [IsReloadCoolingShelfLifeClicked, setIsReloadCoolingShelfLifeClicked] =
        useState(false);
    
    const handleReloadCoolingShelfLifesClick = async () => {
     setIsReloadCoolingShelfLifeClicked(true);
        try { 

            let totalPages = 1;
            let currentPage = 0;
            let allCoolings = [];

            do {
                const response = await CoolingShelfApi?.ListCoolingShelf(currentPage,10);
                totalPages = response?.totalPages;
                allCoolings = [...allCoolings, ...(response?.payloadDto || [])];
                currentPage++;

            } while (currentPage < totalPages);
                setTotalPageNew(totalPages);
                setPage(currentPage);
                setCoolingShelfLifes(allCoolings);
        }
            catch (error) {
                console.log(error);
            } finally {
                setLoading(false);
            }

        setTimeout(() => {
            setIsReloadCoolingShelfLifeClicked(false);
        }, 1000);
    };

    const fetchCoolings = async () => {
        try {
            setLoading(true);

            let totalPages = 1;
            let currentPage = 0;
            let allCoolings = [];

            do {    
                const response = await CoolingShelfApi?.ListCoolingShelf(currentPage,10);
                totalPages = response?.totalPages;
                allCoolings = [...allCoolings, ...(response?.payloadDto || [])];
                currentPage++;
            } while (currentPage < totalPages);
                
            setTotalPageNew(totalPages);
                setPage(currentPage);
                setCoolingShelfLifes(allCoolings);
        } catch (error) {
            console.error('Error fetching departments:', error);
        } finally {
            setLoading(false);
        }
    };


    const handleChangeProduct = (value) => {

        CoolingShelfApi.SingleCoolingProcess(value).then((response) => {
            onCoolingShelfResponse(response.payload);
        })
            .catch((err) => {
                console.log(err);
            });
    };

    useEffect(() => {
        fetchCoolings();
    }, []);

    return (
        <><div className="row product-row d-flex ">
            <Form.Item
                name="CoolingShelfLifeID"
                label="Cooling Shelf Life :"
                className="text-lable col-10"
            >
                <Select
                    className="control-Select mb-1"
                    placeholder="Select Cooling Shelf Life"
                    onChange={(value) => handleChangeProduct(value)}
                >
                    {CoolingShelfLife.map((option, index) => (
                        <Select.Option key={option.id} value={option.id}>
                            {option.description}
                        </Select.Option>
                    ))}
                    {loading && (
                        <Select.Option disabled key="loading" value="loading">
                            Loading...
                        </Select.Option>
                    )}
                </Select>
            </Form.Item>
            <div className=" col-2">
                {IsReloadCoolingShelfLifeClicked ? (
                    <div className="refresh-btn">
                        <SyncOutlined spin className="px-2" />
                    </div>
                ) : (
                    <div
                        className="refresh-btn"
                        onClick={handleReloadCoolingShelfLifesClick}
                        style={{ cursor: "pointer" }}
                    >
                        <ReloadOutlined className="px-2" />
                    </div>
                )}
            </div>
        </div>
            <div className="row pb-2 ">
                <div className="col-4"></div>
                <div className="col-6">
                    <Link to={"/masters/Cooling-Shelf/add-Cooling-Shelf"} target="_blank">
                        <u>Create New Cooling Shelf Life</u>
                    </Link>
                </div>
            </div>
        </>

    );
};

export default CoolingShelfModel;
